export default "__VITE_ASSET__DSFIOOJ7__"